import { useMemo } from "react";
import type { Order } from "../OrderMFE/Orders/types/salesOrder";

/**
 * Builds per–product-item display labels from `order.items[].variationName` / `detail` (no inventory calls).
 * Aligns with OMS `getOrder` enrichment.
 * When labels are missing, `printDocumentMappers.lineItemDisplayName` falls back to `itemId`.
 */
export function usePrintOrderLineDisplayNames(order: Order | null): {
  displayNameByItemId: Record<string, string>;
  isResolving: boolean;
} {
  const displayNameByItemId = useMemo(() => {
    if (!order?.items?.length) return {};
    const out: Record<string, string> = {};
    const seen = new Set<string>();
    for (const it of order.items) {
      if (seen.has(it.itemId)) continue;
      seen.add(it.itemId);
      const v = it.variationName?.trim() || it.detail?.variationName?.trim();
      const p = it.detail?.productName?.trim();
      const label = v || p;
      if (label) out[it.itemId] = label;
    }
    return out;
  }, [order?.orderId, order?.items]);

  return { displayNameByItemId, isResolving: false };
}
